import { forwardRef } from "react";
function SvgRawAddContentIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <circle cx={16} cy={16} r={12} stroke="currentColor" strokeWidth={2} />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={2}
        d="M10 16h12m-6 6V10"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawAddContentIcon);
export default ForwardRef;
